import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker'

import App from "./App";
import isEquipeChatDesktopShell from "./utils/isEquipeChatDesktopShell";

// O app Visita (iframe da aba Cadastro) manda o tamanho da própria bottom-nav
// aqui pra essa página reservar esse espaço embaixo (ver overrides.MuiDialog em
// App.js) — sem isso, dialogs (ex: selecionar motoboy pra rota, editar ficha)
// ficavam com o botão de confirmar/salvar escondido atrás da barra do app.
try {
  const embedBottomInset = new URLSearchParams(window.location.search).get("navInset");
  if (embedBottomInset && Number.isFinite(Number(embedBottomInset))) {
    document.documentElement.style.setProperty("--embed-bottom-inset", `${Number(embedBottomInset)}px`);
  }
} catch (e) {}

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		if (typeof window.finishProgress === "function") {
			window.finishProgress();
		}
	}
);

// CORREÇÃO 08/08/2026: cheguei a desligar esse service worker por engano,
// achando que ele era a causa de correções não aparecerem pro app Visita —
// era erro meu, esse SW (ver public/service-worker.js) é o que entrega
// notificação push pro CRM inteiro, nada a ver com o problema. Revertido.
if (isEquipeChatDesktopShell()) {
  serviceworker.unregister();
} else {
  serviceworker.register();
}
